module.exports = __webpack_public_path__ + "assets/images/img/Matchmaking-01.ce188e1798a3e5237baa7e6071f2a62a.png";